import type { Maybe, ValueEvent } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AbstractAspect } from '@adornis/filter/aspect-schemas/AbstractAspect.js';
import type { AspectConfig } from '@adornis/filter/filter-options.js';
import { html } from 'lit';

@Entity()
export class FundingAspect extends AbstractAspect {
  static override _class = 'FundingAspect';

  @Field(() => String)
  value: Maybe<string>;
}

export const FundingAspectSchema: AspectConfig<FundingAspect> = {
  aspectConstructor: FundingAspect,
  renderEditor: ({ aspectValue }) => html`
    <chancen-component-funding-year-picker
      placeholder="Förderjahr"
      @value-picked=${(e: ValueEvent<string>) => {
        aspectValue.value = e.detail.value;
      }}
      .value=${aspectValue.value}
    ></chancen-component-funding-year-picker>
  `,
  renderPreview: ({ aspectValue }) => (aspectValue.value ? html` ${aspectValue.value} ` : null),
};
